module.exports = __webpack_public_path__ + "70f5b55ebdc772fc5124597d70a1e65b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/bouteille.svg
// module id = 735
// module chunks = 0